angular.module('leanlaw').controller('AttorneyMyRevenueCtrl', ['$scope', '$rootScope', '$q', '$filter', '$state', "alerts", 'userService', 'reportsService', 'accountingService', "exportJson", "messageBus", "singleRequest", function ($scope, $rootScope, $q, $filter, $state, alerts, userService, reportsService, accountingService, exportJson, messageBus, singleRequest) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = ['client.name', 'matter.name'];
  $scope.reverse = false;
  $scope.loading = true;
  $scope.print = function () {
    window.print();
  };
  $scope.go = function (options) {
    options.accountId = $scope.me.id;
    $state.go('reports.attorney-revenue-invoices', options);
  };
  $scope.export = function () {
    const matter = $scope.me.terms.Matter;
    const exp = $scope.data.filtered.reduce((accum, c) => {
      let item = {};
      if ($scope.clientReferences || $scope.references) {
        if ($scope.filter.include && $scope.filter.include.matters) {
          item = {
            "ID": c.client.reference || "",
            [matter]: ""
          };
        } else {
          item = {
            "ID": c.client.reference || ""
          };
        }
      } else if ($scope.filter.include && $scope.filter.include.matters) {
        item = {
          "ID": c.client.reference || "",
          [matter]: ""
        };
      } else {
        item = {};
      }
      item["Client"] = c.client.name;
      item["Worked"] = $filter("amount")(c.data.collected.servicesTotal);
      item["Worked Share"] = $filter("amount")(c.data.origination.share);
      item["Origination"] = $filter("amount")(c.data.origination.debit);
      if ($scope.me.company.settings.report?.responsibleContribution) {
        item["Responsible"] = $filter("amount")(c.data.origination.responsibleDebit);
      }
      if ($scope.me.features.referral) {
        item["Referrals"] = $filter("amount")(c.data.origination.referralDebit);
      }
      item["Total"] = $filter("amount")(c.data.origination.adjusted);
      item["Expenses"] = $filter("amount")(c.data.collected.expensesUsers);
      if ($scope.me.features.referral && $scope.data.data.collected.expensesServices) {
        item["Service Expenses"] = $filter("amount")(c.data.collected.expensesServices);
      }
      if ($scope.filter.showExpense) {
        item["Expenses"] = $filter("amount")(c.data.collected.expensesUsers);
      }
      accum.push(item);
      if ($scope.filter.include && $scope.filter.include.matters) {
        c.matters.forEach(m => {
          item = {
            "ID": m.matter.reference ? !isNaN(m.matter.reference) ? `="${m.matter.reference}"` : m.matter.reference : '',
            "Client": "",
            [matter]: m.matter.name,
            "Worked": $filter("amount")(m.data.collected.servicesTotal)
          };
          item["Worked Share"] = $filter("amount")(m.data.origination.share);
          item["Origination"] = $filter("amount")(m.data.origination.debit);
          if ($scope.me.company.settings.report?.responsibleContribution) {
            item["Responsible"] = $filter("amount")(m.data.origination.responsibleDebit);
          }
          if ($scope.me.features.referral) {
            item["Referrals"] = $filter("amount")(m.data.origination.referralDebit);
          }
          item["Total"] = $filter("amount")(m.data.origination.adjusted);
          item["Expenses"] = $filter("amount")(m.data.collected.expensesUsers);
          if ($scope.me.features.referral && $scope.data.data.collected.expensesServices) {
            item["Service Expenses"] = $filter("amount")(m.data.collected.expensesServices);
          }
          if ($scope.filter.showExpense) {
            item["Expenses"] = $filter("amount")(m.data.collected.expensesUsers);
          }
          accum.push(item);
        });
      }
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  activate();

  ///////////////////////////////////////

  function activate() {
    userService.me().then(me => {
      $scope.me = me;
      accountingService.verify(false).then(status => {
        $scope.accounting = status.connected;
        $scope.$on('commonFilterService-statechanged', (event, payload) => {
          if (!payload) return;
          // Assigning to existing filter keeps custom filter options
          $scope.filter = Object.assign($scope.filter, payload);
          // Necessary to set this value for the requests
          $scope.filter.status = $scope.filter.archived.status;
          $scope.filter.scope = $scope.filter.filter.scope;
          if (payload.filter.range) {
            filterClientEntries();
          }
        });
        $scope.$on("report-sidebar-filterchange", (event, payload) => {
          $scope.filter = Object.assign($scope.filter, payload);
        });

        // MessageBus is used here so that the commonFilter module can pick it up once it loads
        messageBus.addMessage("filterDependency-ready", true);
      });
    });
  }
  let cancelReport = null;
  function filterClientEntries() {
    if (cancelReport) {
      cancelReport.resolve("reloading");
    }
    cancelReport = $q.defer();
    const query = reportsService.queryFromFilter($scope.filter);
    query.account = $scope.me.id;
    query.scope = 'all';
    query.scopeAccount = null;
    query.status = 'all';
    query.data = "payments";
    query.billingType = '-internal';
    query.primary = 'clients';
    query.zeros = false;
    query.$timeout = cancelReport.promise;
    query.reportType = "wip-billed-collected";
    $scope.loading = true;
    singleRequest.apiCall("attorney-my-report", true).getReport(query).then(data => {
      if (!data) return; // happens if we were canceled
      $scope.loading = false;
      $scope.data = data;
      $scope.references = data.clients.some(c => c.matters.some(m => m.matter.reference));
      $scope.clientReferences = data.clients.some(c => c.client.reference);
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("attorney-my-report");
    deactivate();
  });

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filtered = $filter('orderBy')($filter('filter')($scope.data.clients, $scope.search), $scope.sort, $scope.reverse) || [];
    $scope.data.filtered.forEach(client => {
      client.filteredMatters = $filter('orderBy')($filter('filter')(client.matters, $scope.q), $scope.sort, $scope.reverse) || [];
    });
  }
  $scope.$watch('data.clients', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);